import {css, html, LitElement, PropertyValues} from 'lit';
import {customElement, property} from 'lit/decorators';
import {ifDefined} from 'lit-html/directives/if-defined.js';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from '@webs/components-library/theming';
import Swiper from 'swiper';
import {FeatureSection} from './feature-section';
import {IStickyElement, Sticky} from '@webs/components-library/sticky';


@customElement('webs-feature-slider-variant')
export class FeatureSliderVariant extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    moduleSpacingStyles,
    css`
      @font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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') format('woff');font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-container-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-container-multirow>.swiper-wrapper{flex-wrap:wrap}.swiper-container-multirow-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-container-pointer-events{touch-action:pan-y}.swiper-container-pointer-events.swiper-container-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-container-3d{perspective:1200px}.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-container-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}:root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;text-transform:none;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-container-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-container-rtl .swiper-button-next:after{content:'prev'}.swiper-button-next,.swiper-container-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-container-rtl .swiper-button-prev:after{content:'next'}.swiper-button-next.swiper-button-white,.swiper-button-prev.swiper-button-white{--swiper-navigation-color:#ffffff}.swiper-button-next.swiper-button-black,.swiper-button-prev.swiper-button-black{--swiper-navigation-color:#000000}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:8px;height:8px;display:inline-block;border-radius:50%;background:#000;opacity:.2}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:1;background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0px,-50%,0)}.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;display:block}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-container-horizontal>.swiper-pagination-progressbar,.swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-container-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-white{--swiper-pagination-color:#ffffff}.swiper-pagination-black{--swiper-pagination-color:#000000}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-container-horizontal>.swiper-scrollbar{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-container-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;animation:swiper-preloader-spin 1s infinite linear;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{100%{transform:rotate(360deg)}}.swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-container-fade.swiper-container-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-container-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-container-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube{overflow:visible}.swiper-container-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-container-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-cube.swiper-container-rtl .swiper-slide{transform-origin:100% 0}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-container-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-container-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-container-flip{overflow:visible}.swiper-container-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-container-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}
    `,
    css`

      .tabs {
        margin-bottom: 1.1rem;
        overflow-x: auto;
      }

      .tabs ul {
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0 0 2px;
        position: relative;
      }

      .tabs li {
        padding: 0 .6rem;
        border-bottom: 1px solid var(--color-grey);
      }

      .tabs li:first-child {
        padding-left: 0;
      }

      .tabs a {
        color: var(--color-base);
        display: block;
        font-size: .8rem;
        font-weight: var(--font-weight-strong);
        margin-bottom: -1px;
        padding-bottom: .3rem;
        white-space: nowrap;
      }

      .tabs a.current {
        color: var(--color-primary);
        border-bottom: 2px solid var(--color-primary);
        padding-bottom: .25rem;
      }

      scrollable-component {
        --scrollbar-width: .35rem;
        padding-bottom: .5rem;
      }

      .extra-info {
        display: block;
        margin-top: 1.6rem;
      }

      webs-media {
        display: block;
        margin-bottom: 1.6rem;
      }

      @media only screen and (min-width: 768px) {
        .tabs-container {
          position: relative;
          z-index: 3;
        }

        webs-feature::part(content) {
          padding-top: 2.9rem;
          align-self: flex-start;
        }

        .media-container {
          position: relative;
          height: 100%;
        }

        .media-wrapper {
          position: relative;
        }

        webs-media {
          display: block;
          margin-bottom: 0;
        }

        .show {
          opacity: 1;
        }

        .absolute {
          opacity: 0;
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          z-index: -1;
        }

        .fade-out {
          animation-name: fadeout;
          animation-duration: .8s;
          animation-fill-mode: both;
          animation-timing-function: ease-in-out;
        }

        .fade-in {
          opacity: 1;
          animation-name: fadein;
          animation-duration: 1s;
          animation-fill-mode: both;
          animation-timing-function: ease-in-out;
        }

      }

      @keyframes fadein {
          from { opacity: 0; }
          to   { opacity: 1; }
      }

      @keyframes fadeout {
          from { opacity: 1; }
          to   { opacity: 0; }
      }
    `
  ];

  private smallDevice: MediaQueryList = window.matchMedia('(min-width: 768px)');
  private isBreakpoint: boolean;
  @property()
  id: string

  @property({attribute: 'space-top'})
  spaceTop = 'm'

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property({attribute: 'is-contained', type: Boolean})
  isMediaContained: boolean;

  @property({type: Array})
  sections: FeatureSection[] = [
    {
      visual: {
        src: 'https://grow.cleverbridge.com/hubfs/00archive/_system/demo/m-features_placeholder.jpg',
        alt: 'Placeholder'
      },
      video: undefined,
      tabs: [
        {
          title: 'Global compliance',
          header: 'Expand your business globally',
          heading: 'h1',
          content: 'A digitat tincidunt diam at risus mattis, a accumsan dui. Fuse auctor gravida quam in vestibulum. Integer nec metus nec dolor tempus dapibus interdum tempus risus. Curabitur sollicitudin ex mi, eu mollis tortor posuere.',
          checklist: {
            title: 'Key benefits',
            items: ['Fuse auctor gravida quam in vestibulum.', 'Integer nec metus nec dolor tempus.']
          },
          actions: [
            {
              type: 'link',
              title: 'B2B subscription billing',
              link: 'https://grow.cleverbridge.com'
            }
          ]
        },
        {
          title: 'Integrate systems',
          header: 'Lorem ipsum dolor sit amet',
          heading: 'h2',
          content: 'A digitat tincidunt diam at risus mattis, a accumsan dui. Fuse auctor gravida quam in vestibulum. Integer nec metus nec dolor tempus dapibus interdum tempus risus. Curabitur sollicitudin ex mi, eu mollis tortor posuere.',
          checklist: {
            title: 'Key benefits',
            items: ['Fuse auctor gravida quam in vestibulum.', 'Integer nec metus nec dolor tempus.']
          },
          actions: [
            {
              type: 'link',
              title: 'B2B subscription billing',
              link: 'https://grow.cleverbridge.com'
            }
          ]
        }
      ]
    },
    {
      visual: {
        src: 'https://grow.cleverbridge.com/hubfs/00archive/_system/demo/m-features_placeholder-2.jpg',
        alt: 'Placeholder'
      },
      video: undefined,
      tabs: [
        {
          title: 'Global compliance',
          header: 'Expand your business globally',
          heading: 'h2',
          content: 'A digitat tincidunt diam at risus mattis, a accumsan dui. Fuse auctor gravida quam in vestibulum. Integer nec metus nec dolor tempus dapibus interdum tempus risus. Curabitur sollicitudin ex mi, eu mollis tortor posuere.',
          checklist: {
            title: 'Key benefits',
            items: ['Fuse auctor gravida quam in vestibulum.', 'Integer nec metus nec dolor tempus.']
          },
          actions: [
            {
              type: 'link',
              title: 'B2B subscription billing',
              link: 'https://grow.cleverbridge.com'
            }
          ]
        }
      ]
    },
    {
      visual: {
        src: 'https://grow.cleverbridge.com/hubfs/00archive/_system/demo/m-features_placeholder-4.jpg',
        alt: 'Placeholder'
      },
      video: undefined,
      tabs: [
        {
          title: 'Manage offerings',
          header: 'Expand your business globally',
          heading: 'h2',
          content: 'A digitat tincidunt diam at risus mattis, a accumsan dui. Fuse auctor gravida quam in vestibulum. Integer nec metus nec dolor tempus dapibus interdum tempus risus. Curabitur sollicitudin ex mi, eu mollis tortor posuere.',
          quote: {
            quote: '“Ut tincidunt diam at fast page load times and card checkout execution, all over the world.”',
            avatar: 'https://grow.cleverbridge.com/hubfs/00archive/_system/demo/m-features_placeholder-4.jpg',
            quoter: 'Maria Durio',
            extraInfo: 'Chief Financial officer at SaaS'
          },
          actions: [
            {
              type: 'link',
              title: 'B2B subscription billing',
              link: 'https://grow.cleverbridge.com'
            }
          ]
        },
        {
          title: 'Global compliance',
          header: 'Lorem ipsum dolor sit amet',
          heading: 'h2',
          content: 'A digitat tincidunt diam at risus mattis, a accumsan dui. Fuse auctor gravida quam in vestibulum. Integer nec metus nec dolor tempus dapibus interdum tempus risus. Curabitur sollicitudin ex mi, eu mollis tortor posuere.',
          checklist: {
            title: 'Key benefits',
            items: ['Fuse auctor gravida quam in vestibulum.', 'Integer nec metus nec dolor tempus.']
          },
          actions: [
            {
              type: 'button',
              title: 'B2B subscription billing',
              link: 'https://grow.cleverbridge.com'
            },
            {
              type: 'link',
              title: 'B2B subscription billing',
              link: 'https://grow.cleverbridge.com'
            }
          ]
        },
        {
          title: 'Integrate systems',
          header: 'Lorem ipsum dolor sit amet',
          heading: 'h2',
          content: 'A digitat tincidunt diam at risus mattis, a accumsan dui. Fuse auctor gravida quam in vestibulum. Integer nec metus nec dolor tempus dapibus interdum tempus risus. Curabitur sollicitudin ex mi, eu mollis tortor posuere.',
          actions: [
            {
              type: 'link',
              title: 'B2B subscription billing',
              link: 'https://grow.cleverbridge.com'
            }
          ]
        }
      ]
    }
  ]

  connectedCallback() {
    super.connectedCallback();
    this.smallDevice.addEventListener('change', (e) => this.handleDeviceChange(e));
  }

  protected render(): unknown {
    this.handleDeviceChange(this.smallDevice);

    return html`
      <section id="${ifDefined(this.id)}"
               class="m-feature-slider-variant ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div class="container">
          <webs-grid-row class="tabs-container">
            <webs-grid-column sm="6" md="5" class="sections">
              ${this.sections.map((item, index) => {
                return html`
                  <div
                    class="m-feature-slider-variant__section ${index !== 0 && this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${index < (this.sections.length - 1) && this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
                    ${item.tabs.length > 1 ? html`
                      <scrollable-component class="tabs">
                        <ul>
                          ${item.tabs.map((value, index1) => {
                            return html`
                              <li><a class="${index1 === 0 ? 'current' : ''}" href="javascript:;">${value.title}</a>
                              </li>
                            `
                          })}
                        </ul>
                      </scrollable-component>
                    ` : ''}
                    <div class="feature-slider swiper-container">
                      <div class="feature-wrapper swiper-wrapper">
                        ${item.tabs.map((value, index1) => {
                          let title: unknown;
                          switch (value.heading) {
                            case 'h1':
                              title = html`<h1>${value.header}</h1>`;
                              break;
                            case 'h3':
                              title = html`<h3>${value.header}</h3>`;
                              break;
                            case 'h4':
                              title = html`<h4>${value.header}</h4>`;
                              break;
                            case 'h5':
                              title = html`<h5>${value.header}</h5>`;
                              break;
                            case 'h6':
                              title = html`<h6>${value.header}</h6>`;
                              break;
                            default:
                              title = html`<h2>${value.header}</h2>`;
                          }
                          return html`
                            <div class="swiper-slide">
                              ${title}
                              <p>${value.content}</p>
                              ${!this.isBreakpoint ? html`
                                ${this.isMediaContained ? html`
                                  <webs-media src="${item.visual.src}"
                                              alt="${item.visual.alt}" width="600"
                                              video="${ifDefined(item.video)}"></webs-media>
                                ` : html`
                                  <webs-media src="${item.visual.src}"
                                              alt="${item.visual.alt}" height="66.5%" type="cover" width="600"
                                              video="${ifDefined(item.video)}"></webs-media>
                                `}
                              ` : ''}
                              ${value.actions.map((action) => {
                                if (action.link && action.title) {
                                  return action.type === 'link' ? html`
                                    <webs-link-arrow href="${action.link}" text="${action.title}"></webs-link-arrow>
                                  ` : html`
                                    <webs-button href="${action.link}" text="${action.title}"></webs-button>
                                  `
                                }
                              })}
                              ${value.checklist ? html`
                                <webs-checklist class="extra-info" title="${ifDefined(value.checklist.title)}"
                                                .items='${value.checklist.items}'></webs-checklist>
                              ` : ''}
                              ${value.quote ? html`
                                <webs-card-quote class="extra-info"
                                                 quote="${ifDefined(value.quote.quote)}"
                                                 avatar="${ifDefined(value.quote.avatar)}"
                                                 quoter="${ifDefined(value.quote.quoter)}"
                                                 extra-info="${ifDefined(value.quote.extraInfo)}"
                                ></webs-card-quote>
                              ` : ''}
                            </div>
                          `
                        })}
                      </div>
                    </div>
                  </div>
                `;
              })}
            </webs-grid-column>
            ${this.isBreakpoint ? html`
              <webs-grid-column sm="6" md="6" md-offset="1" class="media">
                <div class="media-container" data-sticky-container>
                  <div class="media-wrapper sticky" data-margin-top="80">
                    ${this.sections.map((item, index) => {
                      return this.isMediaContained ? html`
                        <webs-media class="${index === 0 ? 'active' : 'absolute'}" src="${item.visual.src}"
                                    alt="${item.visual.alt}" width="600" height="66.5%" type="contain"
                                    video="${ifDefined(item.video)}"></webs-media>
                      ` : html`
                        <webs-media class="${index === 0 ? 'active' : 'absolute'}" src="${item.visual.src}"
                                    alt="${item.visual.alt}" height="66.5%" type="cover" width="600"
                                    video="${ifDefined(item.video)}"></webs-media>
                      `
                    })}
                  </div>
                </div>
              </webs-grid-column>
            ` : ''}
          </webs-grid-row>
        </div>
      </section>
    `
  }

  protected async firstUpdated(changedProperties: PropertyValues): Promise<void> {
    await new Promise((r) => setTimeout(r, 0));

    const sectionsHtml: NodeListOf<HTMLElement> = this.shadowRoot.querySelectorAll('.m-feature-slider-variant__section');
    const offsetPoints: number[] = [];

    for (let i = 0; i < sectionsHtml.length; i++) {
      offsetPoints.push(window.pageYOffset + sectionsHtml[i].getBoundingClientRect().top);

      const featureSlider: HTMLElement = sectionsHtml[i].querySelector('.feature-slider');
      const tabs: NodeListOf<HTMLAnchorElement> = sectionsHtml[i].querySelectorAll('.tabs a');

      const featureSwiper: Swiper = this.addFeatureSlider(featureSlider, tabs);
      for (let i = 0; i < tabs.length; i++) {
        tabs[i].addEventListener('click', ev => {
          ev.preventDefault();
          const currentTab = ev.target as HTMLAnchorElement;
          const siblings = Array.from(currentTab.parentNode.children).filter((child) =>
            child !== currentTab
          );
          siblings.forEach(value => value.classList.remove('current'));
          currentTab.classList.add('current');
          featureSwiper.slideTo(i);
        });
      }
    }
    this.addScrollEvent(offsetPoints);
  }

  private addScrollEvent(offsetPoints: number[]): void {
    const mediaWrapper: NodeListOf<IStickyElement> = this.shadowRoot.querySelectorAll<IStickyElement>('.media-wrapper');
    const sticky: Sticky = new Sticky(mediaWrapper);

    document.addEventListener('scroll', () => {
      this.updateActiveMedia(offsetPoints);
    });
  }

  private updateActiveMedia(offsetPoints: number[]): void {
    const mediaItems = this.shadowRoot.querySelectorAll('webs-media');
    const sticky: HTMLElement = this.shadowRoot.querySelector('.sticky');
    const activeMedia: HTMLElement = this.shadowRoot.querySelector('.active');
    const stickyBottom: number = window.pageYOffset + sticky.offsetHeight;

    const currentOffsetPointIndex = this.getCurrentMediaIndexOrUndefined(offsetPoints, stickyBottom);

    const activeMediaIndex = Array.from(mediaItems).findIndex(value => value.classList.contains('active'));

    if (currentOffsetPointIndex === undefined && mediaItems.length > 0) {
      if (activeMedia) {
        activeMedia.classList.remove('active', 'fade-in');
        activeMedia.classList.add('absolute');
      }
      mediaItems[0].classList.remove('fade-out', 'absolute');
      mediaItems[0].classList.add('active');
    }

    if (currentOffsetPointIndex !== undefined && currentOffsetPointIndex > -1 && currentOffsetPointIndex < offsetPoints.length && currentOffsetPointIndex !== activeMediaIndex) {
      if (activeMedia) {
        activeMedia.classList.remove('active', 'fade-in');
        activeMedia.classList.add('fade-out', 'absolute');
      }
      mediaItems[currentOffsetPointIndex].classList.remove('fade-out', 'absolute');
      mediaItems[currentOffsetPointIndex].classList.add('fade-in', 'active');
    }
  }

  private getCurrentMediaIndexOrUndefined(offsetPoints: number[], stickyBottom: number): number {
    const currentOffsetPoint = offsetPoints
      .slice()
      .sort((a, b) => a - b)
      .reverse()
      .find(value => stickyBottom >= value);

    if (currentOffsetPoint) {
      return offsetPoints.indexOf(currentOffsetPoint);
    } else {
      return undefined;
    }
  }

  private addFeatureSlider(featureSlider, tabs): Swiper {
    return new Swiper(featureSlider, {
      spaceBetween: 100,
      on: {
        slideChange: (swiper) => {
          const currentItem: HTMLAnchorElement = tabs[swiper.activeIndex];
          tabs.forEach(value => value.classList.remove('current'));
          currentItem.classList.add('current');
        },
      }
    });
  }

  private handleDeviceChange(event): void {
    this.isBreakpoint = event.matches;
    this.requestUpdate();
  }
}
